export default __webpack_public_path__ + "static/media/shock.8a0a15f6.png";